import { ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const descriptionsFilterSelect: ThemedFunctor = () => css`
    min-width: 10rem;
`;
